import { ChainId } from 'types/chains';
export const CONTRACT_ADDRESSES = {
    [ChainId.MerlinTestnet]: '0xdCA47EbA4FdC163aadc42C2eB9beE7fBDD37a5F3',
    [ChainId.EthereumHolesky]: '0x9Eedf788eb20b55dD95C98dEa1948F2103AB9F93',
    [ChainId.Sepolia]: '0x493e56d137Cc824776Cac7f54E20665C8eBAC431',
    /// [ChainId.BobSepolia]: '0xe8c918ccc1215be6ac618bc9c2b807d8d35519d4',
    [ChainId.BaseSepolia]: '0x570A7662B5B13B02d63a2b96Fbc233D8B729d845',
    [ChainId.ModeSepolia]: '0xc69B0F10e7b278c306F35b34A0189af549D490DC',
    [ChainId.ArbitrumSepolia]: '0x54DFa12628822066437802f42e891d3c07E3cf5d',
    [ChainId.CoreTestnet2]: '0x6d8BdF5Df15CD3074B5E1F5584a13e6C20599575',
};
